import './App.css';
import "leaflet/dist/leaflet.css";
import Navbar from './components/Navbar';
import ScrollToTop from "./components/ScrollToTop";
import { BrowserRouter as Router, Switch,Route ,Routes} from 'react-router-dom';
import Home from './components/Home';
import Aircraft from './components/Aircraft';
import Details from './components/Details';
import ContactPage from './components/ContactPage';
import About from './components/About';

function App() {
  return (
   <>
<Router>

  <Navbar />
  <ScrollToTop />
  <Routes>
    <Route path="/" element={<Home />} />
    <Route path= "/aircrafts" element={<Aircraft/>}/>
    <Route path="/aircrafts/:id" element={<Details/>}/>
    <Route path="/contact" element={<ContactPage/>}/>
    <Route path="/about" element={<About/>}/>


  </Routes>
</Router>
   </>
   
 
  );
}


export default App;
